<template>
<div class="table-page-wrapper">
  <date-format-select @changeDateFormatData="changeDateFormatData($event.dateFormatId)" :isMonthly="true"   style="margin-right: 15px;margin-bottom: 15px;" />
    <search-channel-select v-model="listQuery.channelId" style="margin-right: 15px;margin-bottom: 15px;" />
    <search-channel-slot-select v-model="listQuery.slotId"   style="margin-right: 15px;margin-bottom: 15px;" />
      <search-dsp-select v-model="listQuery.dspId" style="margin-right: 15px;margin-bottom: 15px;" />
      <search-dsp-slot-select
        v-model="listQuery.dspSlotId"
        :dsp-id="listQuery.dspId"
      />
      <base-date-picker @changeDate="changeDate" style="margin-right: 15px;margin-bottom: 15px;" />
      <el-button @click="search" type="primary"  >搜索</el-button>
      <el-button
     @click="downExcel('/clk/behavior/csv', '点击行为报表', listQuery)"
      type="primary" >下载</el-button>

    <el-table
    :data="tableData"
    class="js-table"
    border >
    <el-table-column
      prop="channelName"
      label="渠道名称"
      align="center">
    </el-table-column>
    <el-table-column
      prop="dspName"
    align="center"
      label="DSP名称">
    </el-table-column>
    <el-table-column
      prop="slotId"
    align="center"
      label="广告位编号">
    </el-table-column>
    <el-table-column
      prop="slotName"
    align="center"
      label="渠道广告位名称">
    </el-table-column>
    <el-table-column
      prop="dspSlotName"
    align="center"
      label="DSP广告位名称">
    </el-table-column>
    <el-table-column
      prop="replaceRatio"
    align="center"
      label="替换比例">
    </el-table-column>
    <el-table-column
      prop="regular"
    align="center"
      label="常规触屏点击">
    </el-table-column>
    <el-table-column
      prop="swipe"
    align="center"
      label="滑动点击">
    </el-table-column>
    <el-table-column
      prop="shake"
    align="center"
      label="摇一摇">
    </el-table-column>
    <el-table-column
      prop="customGestures"
    align="center"
      label="自定义手势">
    </el-table-column>
    <el-table-column
      prop="twist"
    align="center"
      label="扭一扭">
    </el-table-column>
    <el-table-column
      prop="erase"
    align="center"
      label="擦除">
    </el-table-column>
    <el-table-column
      prop="abnormal"
    align="center"
      label="异常行为">
    </el-table-column>
  </el-table>
  <el-pagination
            :current-page.sync="listQuery.pageNum"
            :page-sizes="[10, 20, 30, 50]"
            :page-size.sync="listQuery.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="currentChange"
            style="text-align:center;margin-top:10px;margin-bottom: 50px;"
          />
</div>
</template>

<script>
import {getClickList} from '@/api/manage/clickAction/clickAction'
import {formatDate,PURE_DATE_PATTERN} from '@/util/format'
import downExcelMixin from "@/mixins/downExcel";
import DateFormatSelect from "@/components/DateFormatSelect";
import SearchChannelSelect from "@/components/SearchChannelSelect";
import SearchDspSlotSelect from "@/components/SearchDspSlotSelect";
import SearchDspSelect from "@/components/SearchDspSelect";
import SearchChannelSlotSelect from "@/components/SearchChannelSlotSelect";
import BaseDatePicker from "@/components/BaseDatePicker";
export default{
    name: 'clickAction',
    components: {
    DateFormatSelect,
    SearchChannelSelect,
    SearchDspSelect,
    SearchDspSlotSelect,
    BaseDatePicker,
    SearchChannelSlotSelect,
  },
    mixins: [downExcelMixin],
    data(){
        return{
            tableData:[],
            listQuery:{
              endTime:'',
              pageNum:1,
              pageSize:30,
              startTime:'',
              dspSlotId:'',         //DSP广告位编号
              dspId:'',             //DSP编号
              slotId:'',            //渠道广告位编号
              channelId:''           //渠道编号
            },
            total:undefined
        }
    },
    methods:{
      //获取列表
      async getData(){
        const res = await getClickList(this.listQuery)
        this.tableData = res.data.records
        this.total = res.data.total
      },
      //页码切换
      sizeChange(e){
        this.listQuery.pageSize = e
        this.getData()
      },
      //当前页切换
      currentChange(e){
        this.listQuery.pageNum=e
        this.getData()
      },
      //搜索
      search(){
        this.listQuery.pageNum = 1
        this.getData()
      },
      //处理日期
      changeDateFormatData(dateFormatId) {
      this.dateFormatId = dateFormatId;
      this.listQuery.isDay = null;
      this.listQuery.isHour = null;
      this.listQuery.isMonth = null;
      if (dateFormatId === 0) {
        this.listQuery.isDay = 2;
        this.listQuery.isHour = 2;
        this.listQuery.isMonth = 2;
      } else if (dateFormatId === 1) {
        this.listQuery.isDay = 1;
      } else if (dateFormatId === 2) {
        this.listQuery.isHour = 1;
      } else if (dateFormatId === 3) {
        this.listQuery.isMonth = 1;
      }
      this.listQuery.asc = "";
      this.listQuery.desc = "";
    },
    //修改时间
    changeDate(date) {
      this.listQuery.startTime = date.startTime;
      this.listQuery.endTime = date.endTime;
    },
  },
    created(){
      this.getData()
    },

}
</script>

<style lang="scss" scoped>
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  &>* {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  &>.el-select,
  &>.el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-pagination {
  text-align: right;
}

::v-deep.el-table__placeholder {
  display: none;
}

::v-deep.el-table__expand-icon {
  width: auto !important;
}
</style>
